import { Link } from 'react-router-dom';
import { Button } from '@medikei/ui';
import { ShieldOff, Home } from 'lucide-react';

export function UnauthorizedPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center">
        <div className="w-24 h-24 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-6">
          <ShieldOff size={48} className="text-destructive" />
        </div>
        <h1 className="text-6xl font-bold text-foreground mb-2">403</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          Access Denied
        </h2>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">
          You don&apos;t have permission to access this page. Please contact your
          administrator if you believe this is an error.
        </p>
        <Link to="/dashboard">
          <Button>
            <Home size={18} />
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
